import React from 'react'
import About from "../../Assets/images/about-pic.jpg";

function Aboutarea() {
    return (
        <>
            <div className="aon-about-area">
                <div className="container">
                    <div className="section-content">
                        <div className="row d-flex flex-wrap align-items-center a-b-none">
                            <div className="col-lg-6 col-md-12">
                                <div className="aon-about-pic">
                                    <img src={About} alt="" />
                                </div>
                            </div>
                            <div className="col-lg-6 col-md-12">
                                {/*Title Section Start*/}
                                <div className="section-head">
                                    <span className="aon-sub-title">About</span>
                                    <h2 className="sf-title">
                                        Upgrade Your Skills With Service Finder
                                    </h2>
                                    <p>
                                        Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed
                                        do eiusmod tempor incididunt ut labore et dolore magna aliqua.
                                        Quis ipsum suspendisse ultrices gravidem ipsum dolor sit amet,
                                        consectetur adipiscing elit, sed do eiusmod tempor incididunt
                                        ut labore et dolore magna aliqua. Quis ipsum suspendisse
                                        ultrices gravidal abore et dolore magna aliqua.{" "}
                                    </p>
                                </div>
                                {/*Title Section End*/}
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </>
    )
}

export default Aboutarea
